import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';
import contrastedText from '../../UI/utils/contrastedText';

interface IMusicGenreContainerProps {
  color: string;
  index: number;
}

const bounceAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  33% {
    transform: translateY(-2px);
  }
  66% {
    transform: translateY(2px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const MusicGenreContainer = styled(motion.li)<IMusicGenreContainerProps>`
  margin: 0.5rem;
  position: relative;
  max-width: calc(50% - 1rem);
  flex: 0 0 calc(50% - 1rem);
  background-color: ${({ color }) => color};
  font-family: ${({ theme }) => theme.fonts.secondary.bold};
  color: ${({ color, theme }) => (contrastedText(color) ? theme.colors.White : theme.colors.Black)};
  text-align: center;
  text-transform: uppercase;
  font-size: 1.25rem;
  animation: ${bounceAnimation} 5s infinite;
  animation-delay: ${({ index }) => index * 0.2}s;

  @media screen and ${min('tablet')} {
    font-size: 1.5rem;
    max-width: calc(25% - 1rem);
    flex: 0 0 calc(25% - 1rem);
  }
  @media screen and ${min('largeTablet')} {
    height: 0;
    max-width: calc(12.5% - 1rem);
    flex: 0 0 calc(12.5% - 1rem);
    padding-bottom: calc(12.5% - 1rem);
  }
`;

export const MusicGenreTitleContainer = styled.div`
  padding: 1.25rem;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and ${min('largeTablet')} {
    position: absolute;
    top: 0;
    left: 0;
    padding: 1rem;
  }
`;

export const MusicGenreTitle = styled.div``;
